import { request } from '../../common/request';
import { log } from '../../common/log';
import { report } from '../../common/profile';
import { modal } from './modal';
import { $el } from '../../common/elements';
import { keys as headerKeys, values as headerValues } from '../../common/headers';
import { article as articleUrl } from '../../common/urls';
import { video } from '../../common/regex';

async function getArticle(id = '') {
  let result;

  try {
    const res = await request(articleUrl.replace('{{id}}', id), {
      headers: {
        [headerKeys.accept]: headerValues.json,
      },
    });

    if (res.ok) {
      const data = await res.json();

      result = data.data;
    }
  } catch (err) {
    log(`Failed to retrieve description of ${id}`);
  }

  return result;
}

export async function article(arg) {
  const rec = await getArticle(arg);
  const uri = rec.URL;
  const isVideo = video.test(uri);

  report({
    id: rec.id || arg,
    href: uri,
    type: 'cards',
    video: isVideo,
  });

  if (isVideo) {
    modal('video', uri, 'video');
  } else {
    const fn = () => window.open(uri, '_blank');

    $el.launcher.addEventListener('click', fn, false);
    $el.launcher.click();
    $el.launcher.removeEventListener('click', fn);
  }
}
